import * as React from "react";
import { IOnderhoudPageProps } from "./IOnderhoudPageProps";
import { onderhoudBasePage } from "./onderhoudBasePage";

export function OnderhoudPageNl(props: IOnderhoudPageProps) {
  const pageMessage =
    "In verband met onderhoud kunt u tijdelijk geen contact met ons opnemen via een webformulier. Onze excuses voor het ongemak.";
  return onderhoudBasePage("CAK - Onderhoud", "In onderhoud", pageMessage);
}
